<template>
    <div class="us_app">
        <section class="user_section">
            <div class="title jc">
                <h2>QnA 등록</h2>
            </div>
                                  
            <article class="view">
                <!-- QnA  -->
                <div class="table_list">
                    <table class="write">
                        <colgroup>
                            <col width="200">
                            <col width="30%">
                            <col width="200">
                            <col width="30%">
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>제목</th>
                                <td colspan="3"><input type="text" class="form_control" v-model="regData.qna_title" placeholder="입력해주세요"></td>
                            </tr>                                    
                            <tr>
                                <th>작성자</th>
                                <td><span class="fwb">{{regData.clinicDoctorNm}}</span></td>
                            </tr>       
                            <tr>
                                <th>비밀여부</th>
                                <td>
                                    <div class="form_inline">
                                        <div class="form_radio">
                                            <input type="radio" id="radio1" name="radio" v-model="regData.scret_yn" value="N">
                                            <label for="radio1">공개</label>
                                        </div>
                                        <div class="form_radio">
                                            <input type="radio" id="radio2" name="radio" v-model="regData.scret_yn" value="Y">
                                            <label for="radio2">비공개</label>
                                        </div>
                                    </div>                                    
                                </td>
                                <th>비밀번호</th>
                                <td><input type="password" class="form_control" v-model="regData.qna_pw" placeholder="입력해주세요"></td>
                            </tr>                                       
                            <tr>
                                <th>내용</th>
                                <td colspan="3">
                                    <textarea 
                                        class="form_control"
                                        placeholder="입력해주세요."
                                        style="min-height: 400px"
                                        v-model="regData.question_contents"
                                    >
                                    </textarea>
                                </td>
                            </tr>   
                        </tbody>
                    </table>
                    <div class="bottom_box bn">
                        <button 
                            class="btn btn_md btn_darkbrown"
                            @click="fn_move_listPage"
                        >
                                목록
                        </button>
                        <button 
                            class="btn btn_md btn_brown"
                            @click="fn_qna_vailidation"
                        >
                                저장
                        </button>
                    </div>                    
                </div>
            </article> 
        </section>
        <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        :closeEventValue="closeEventValue"
        @closeEvent="oncCloseEvent"
        v-on:update:showSetting="fn_showSet"
        />
    </div>
</template>

<script>
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    export default {
        components: {
            'alert-modal' : AlertModal,
            //'confirm-modal': AlertModal,
        },
        mixins: [alertutill],
        data () {
            return {
                regData : {
                    clinicDoctorId : '',
                    clinicDoctorNm : '',
                    qna_seq : '',
                    qna_title : '',
                    scret_yn : 'Y',
                    qna_pw : '',
                    question_contents : '',
                    response_contents : '',
                    response_reg_id : '',
                    status : ''
                }
            }
        },
        mounted(){
            this.regData.clinicDoctorId = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
            this.regData.clinicDoctorNm = this.$store.getters['clinicDoctorInfo/getDoctorNm'];
        },
        methods : {
           fn_qna_vailidation(){
                if(this.regData.qna_title == ''){
                    let msg = "제목을 입력해주세요";
                    this.fn_open_alert(msg); 
                    return false;
                }

                if(this.regData.scret_yn == ""){
                    if(this.regData.qna_pw == ""){
                        let msg = "비밀번호를 입력해주세요";
                        this.fn_open_alert(msg); 
                        return false;
                    }
                }

                if(this.regData.question_contents == "" ){
                    let msg = "내용를 입력해주세요";
                    this.fn_open_alert(msg);
                    return false;
                }

                this.fn_qna_reg();

           },
           fn_qna_reg(){
            console.log("@@@@ this.regData : %o",this.regData);
            axios
                .post("/api/user/board/regQna", this.regData)
                .then((res) => {                            
                    console.log("@@@@ res : %o",res);

                    let msg = "저장되었습니다.";
                    this.fn_open_alert_close(msg);
                    
                    
                })
                .catch((err) => console.log(err));
            },
            fn_move_listPage(){
                this.$router.push("/qna");
            },
            oncCloseEvent(){
                this.fn_move_listPage();
            } 
        }
    }
</script>